module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_null.98e18ff4.png";